import Grid from "components/Grid";
import Text from "components/Text";
import { FC } from "react";
import { GoPencil } from "react-icons/go";
import { useNavigate, useParams } from "react-router-dom";
import {
    CardTitleLeft,
    PencilButton,
} from "../PersonalInfo/PersonalInfo.styled";

export const CardTitle: FC<{
    icon: React.ReactNode;
    title: string;
    editRoute: string;
}> = ({ title, icon, editRoute }) => {
    const { id: agency_id } = useParams();
    const navigateTo = useNavigate();
    const handleEdit = () => {
        navigateTo(editRoute);
    };
    return (
        <Grid row={true} justify="space-between" expanded>
            <CardTitleLeft>
                {icon}
                <Text variant="heading4" fontWeight="700" color="#434343">
                    {title}
                </Text>
            </CardTitleLeft>
            {!agency_id && (
                <PencilButton
                    size="small"
                    variant="outlined"
                    onClick={handleEdit}
                >
                    <GoPencil />
                </PencilButton>
            )}
        </Grid>
    );
};
